import React from "react";
import AppHeader from "./AppHeader";

export default function ManagementHeader(props) {
  return <AppHeader variant="management" {...props} />;
}
